import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './Guide.module.scss';

export const GuideStepOne = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.guideLeftSection}>
        <span className={styles.guideStepLeft_1}>The</span>
        <span className={styles.guideStepLeft_2}>Guide</span>
        <span className={styles.guideStepLeft_3}>to a sustainable</span>
        <span className={styles.guideStepLeft_4}>technological</span>
        <span className={styles.guideStepLeft_5}>future</span>
      </div>
    }
    rightContent={
      <div className={styles.guideStepContentWrapper}>
        To uphold the principles of the TransparenTerra community, we’re building a sustainable and
        resilient future for our planet together. When you join TransparenTerra, you support: <br />
        - Transparency and Trust
        <br />
        - Productive interaction and cooperation
        <br />
        - Proactive climate change
        <br />
      </div>
    }
  />
);
